import React, { useContext, useEffect, useState } from "react";
import { AuthorizedLayoutCompanies } from "../../components/AuthorizedLayoutCompanies";
import { AuthContext } from "../../providers/AuthProvider";
import { useSearchParams } from "react-router-dom";
import iconLOcal from "../../assets/Vector (28).png";
import iconFoguete from "../../assets/foguette_elon.svg";
import "./Profile.css";
import FormProfile from "./FormProfile";
import CompanyPlanDetails from "./CompanyPlanDetails";
import api from "../../utils/api";
import CompanyAvatar from "../../components/CompanyAvatar/CompanyAvatar";
import { Email, WhatsApp } from "@mui/icons-material";
import { usePlanPermissions } from "../../hooks/usePlanPermissions";
import TooltipCustom from "../../components/TooltipCustom";

const Profile = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const { user, updateUser, signOut } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "profile");
  const [company, setCompany] = useState(null);
  const { hasSupportWhatsAppAccess } = usePlanPermissions();

  const getCompany = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/companies/companies/${user.id}`);

      if (data.data) {
        setCompany({
          ...data?.data.attributes,
          id: data?.data.id,
          address: data?.data.attributes.address || {}
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (tabFromUrl && tabFromUrl !== "financial") {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  const handleTabClick = (tab) => {
    // Block only financial tab
    if (tab === "financial") {
      return;
    }
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <AuthorizedLayoutCompanies>
      <div className="containerPainelProfile">
        <div className="headerPainel">
          <div>
            <div className="titlePanel">Meu Perfil</div>
          </div>
        </div>

        <div className="contentContainer">
          <div className="containerLeft">
            <CompanyAvatar
              avatar={user?.avatar}
              width="137px"
              height="137px"
            />
            <div
              style={{ display: "flex", flexDirection: "column", gap: "3px" }}
            >
              <div className="companyName">{user?.companyName}</div>
              <div className="companyPlan">
                <strong>Plano atual: </strong>{user?.subscription?.paymentPlan?.name}
              </div>
            </div>

            <div className="subtitlePanel">
              <img src={iconLOcal} alt="" />
              {user?.address?.city && user?.address?.state
                ? `${user.address.city} - ${user.address.state}`
                : user?.address?.city || user?.address?.state || "Endereço não informado"}
            </div>

            <div className="subtitlePanel">
              {user?.companyDescription}
            </div>

            <div className="cardInfoProfile">
              <div className="box1">
                <div className="supportTitle">Precisa de ajuda? </div>
                <div className="supportSubtitle">Entre em contato conosco, nosso time está a pronto para te auxiliar.</div>

                <div
                  className="containerInfoBox"
                  onClick={() => window.open("mailto:ajuda@ecomlovers.com", "_blank")}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "18px",
                      height: "18px",
                    }}
                  >
                    <Email style={{ width: "16px", height: "16px", color: "#211E1F" }} />
                  </div>
                  <div className="text">ajuda@ecomlovers.com</div>
                </div>

                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <div
                    className="containerInfoBox"
                    style={{ 
                      pointerEvents: !hasSupportWhatsAppAccess() ? 'none' : 'auto',
                      flex: 1
                    }}
                    onClick={() => hasSupportWhatsAppAccess() && window.open("https://wa.me/551152867310", "_blank")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "18px",
                        height: "18px"
                      }}
                    >
                      <WhatsApp style={{ width: "16px", height: "16px", color: "#211E1F" }} />
                    </div>
                    <div 
                      className="text"
                      style={{ filter: !hasSupportWhatsAppAccess() ? 'blur(3px)' : 'none' }}
                    >
                      {!hasSupportWhatsAppAccess() ? '(11) 1234-5678' : '(11) 5286-7310'}
                    </div>
                  </div>
                  {!hasSupportWhatsAppAccess() && (
                    <TooltipCustom disabled={true}>
                      <img src={iconFoguete} alt="" style={{ width: "20px", height: "20px", cursor: 'pointer' }} />
                    </TooltipCustom>
                  )}
                </div>
              </div>
            </div>

            <div
              onClick={() => signOut()}
              className="buttonSiginOut"
            >
              Sair da conta
            </div>
          </div>

          <div className="containerRight">
            <div className="tabs-container">
              <div className="tabs-header">
                <button
                  className={`tab-button ${
                    activeTab === "profile" ? "active" : "" 
                  }`}
                  onClick={() => handleTabClick("profile")}
                >
                  Perfil
                </button>
                <button
                  className={`tab-button ${
                    activeTab === "plan" ? "active" : ""
                  }`}
                  onClick={() => handleTabClick("plan")}
                >
                  Plano
                </button>
                <button
                  className={`tab-button ${
                    activeTab === "financial" ? "active" : ""
                  } disabled`}
                  onClick={() => handleTabClick("financial")}
                  title="Funcionalidade em desenvolvimento"
                >
                  Financeiro
                </button>
              </div>
              <div className="tab-content">
                {activeTab === "profile" && (
                  <FormProfile company={user} updateUser={updateUser} />
                )}
                {activeTab === "plan" && (
                  <CompanyPlanDetails company={user} />
                )}
                {activeTab === "financial" && <h1>Financeiro</h1>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthorizedLayoutCompanies>
  );
};

export default Profile;
